var exports = {
  "k": "xa15a2ab7--de6207--container",
};

module.exports = exports;
